import { Component, inject, signal, HostListener, ElementRef } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  public state = inject(AppStateService);
  public isMobileMenuOpen = signal(false);
  public isNetworkMenuOpen = signal(false);

  constructor(private elementRef: ElementRef) {}

  toggleMobileMenu() {
    this.isMobileMenuOpen.update(v => !v);
  }

  toggleNetworkMenu(event: Event) {
    event.stopPropagation();
    this.isNetworkMenuOpen.update(v => !v);
  }

  selectNetwork(id: string) {
    this.state.selectNetwork(id);
    this.isNetworkMenuOpen.set(false);
  }

  selectNav(id: string) {
    this.state.selectNav(id);
    this.isMobileMenuOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isNetworkMenuOpen.set(false);
    }
  }
}
